export default __webpack_public_path__ + "static/media/illustration-features-tab-2.8e4b1cb2.png";